/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ day: NonNullable<unknown>, rank: NonNullable<unknown> }} Calendar_Quota_Notice_Consumes_Week_OtherInputs */

const fr_calendar_quota_notice_consumes_week_other = /** @type {(inputs: Calendar_Quota_Notice_Consumes_Week_OtherInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Utilise 1 séance — ${i?.day} deviendra ta ${i?.rank}ᵉ séance de la semaine`)
};

/**

* @param {Calendar_Quota_Notice_Consumes_Week_OtherInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const calendar_quota_notice_consumes_week_other = /** @type {((inputs: Calendar_Quota_Notice_Consumes_Week_OtherInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calendar_Quota_Notice_Consumes_Week_OtherInputs, { locale?: "fr" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_calendar_quota_notice_consumes_week_other(inputs)
});